module.exports = __webpack_public_path__ + "img/empty-list-data.2611ca0b.png";